import { render, staticRenderFns } from "./editsummarystockinfo.vue?vue&type=template&id=b11af9cc"
import script from "./editsummarystockinfo.vue?vue&type=script&lang=js"
export * from "./editsummarystockinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports